// extracted by mini-css-extract-plugin
module.exports = {"youtubeIconWrp":"RelatedVideos_youtubeIconWrp__EC3wD","imgItem":"RelatedVideos_imgItem__P7KdJ","youtubeIcon":"RelatedVideos_youtubeIcon__nFAJF"};